import React from 'react';
import styles from './styles/Info.module.scss';

type InfoProps = {
  children: React.JSX.Element | string | (React.JSX.Element | string)[];
  color?: string;
  margin?: 'top' | 'bottom' | 'y';
};

const Info: React.FunctionComponent<InfoProps> = (props: InfoProps) => (
  <div
    className={`${styles.info} ${props.color ? styles[`color-${props.color}`] : undefined} ${
      props.margin ? styles[`margin-${props.margin}`] : undefined
    }`}
  >
    <p>{props.children}</p>
  </div>
);

export default Info;
